
import React from 'react';

const LegalTransmissionObligation = () => {
  return (
    <div>
      <h3 className="text-xl font-semibold mb-3">XII. Legal obligation to transmit certain data</h3>
      <p className="text-gray-600">
        Under certain circumstances, we may be subject to a special legal or regulatory obligation to provide lawfully processed personal data to third parties, especially public authorities (cf. Art. 6 para. 1 let. c EU-GDPR).
      </p>
    </div>
  );
};

export default LegalTransmissionObligation;
